export default __webpack_public_path__ + "static/media/18577 - Vandy.e3e7b2e0.jpeg";